var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGemmaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6cb8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#a78bfa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ic"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#1a1f3a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 170,
    fill: "none",
    stroke: "url(#g1)",
    strokeWidth: 3.5,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 86 C256 183 183 256 86 256 C183 256 256 329 256 426 C256 329 329 256 426 256 C329 256 256 183 256 86Z",
    fill: "url(#g1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemmaIcon);
export default __webpack_public_path__ + "static/media/gemma-icon.d33cb763709ae2aa939ca1b8f28efaf4.svg";
export { ForwardRef as ReactComponent };